// removed by extract-text-webpack-plugin
module.exports = {"preview":"_2_nbd8ssb4wOFBVB-XLVaS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/EmailWysiwyg.scss
// module id = 1309
// module chunks = 1